export default __webpack_public_path__ + "static/media/App-logo.a7325ce2.png";